<template>
  <AppFormGroup v-if="applicantType === ApplicantType.PRIMARY">
    <SubHeading keypath="headings.bank" />

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <AppField path="bankAccount.bankName" />
      <AppField path="bankAccount.autoPay" />
    </div>

    <div>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <AppField path="bankAccount.routingNumber" />
        <AppField path="bankAccount.accountNumber" privacy-mode="last4" />
      </div>
      <i18n-t
        v-if="te('account-disclosure')"
        tag="p"
        class="-mt-4 mb-2 text-sm"
        keypath="account-disclosure"
      />
    </div>

    <div class="flex flex-row items-center justify-center">
      <CheckDetails class="w-3/4 md:w-1/2 lg:w-1/3" />
    </div>
  </AppFormGroup>
</template>

<script setup lang="ts">
  import {
    AppField,
    AppFormGroup,
  } from "@versatile-credit-apply/components/form"
  import { CheckDetails } from "@versatile-credit-apply/components"
  import { ApplicantType } from "@versatile-credit-apply/omni-apply-client"
  import { useProviderI18n } from "@versatile-credit-apply/sdk"
  import type { FormSectionProps } from "./form-section-api"

  const props = defineProps<FormSectionProps>()

  const { te } = useProviderI18n(() => props.providerKey)
</script>

<i18n lang="yaml" locale="en">
appFields:
  accountNumber:
    label: Account Number
  autoPay:
    label: Auto-Pay
  bankName:
    label: Bank Name
  routingNumber:
    label: Routing Number
headings:
  bank: Bank Account
</i18n>

<i18n lang="yaml" locale="snap_standard_en">
account-disclosure: >
  Please verify you have an active checking account.
  If you are approved, you will have options later to setup recurring payments.
</i18n>
